<div
    [ngClass]="{'scss-block-color-variable-font': kind === WebsiteBlockTextAndMediaType.HeroBackgroundImage}"
    class="scss-website-background-color">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <div class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.ReadOnly) {
            <div class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent>
    <div class="w-100 hero-block">
        <div class="w-100 d-grid"  [ngClass]="{
            'custom-square-side-image': kind === WebsiteBlockTextAndMediaType.HeroSquareSideImage || kind === WebsiteBlockTextAndMediaType.MediaLeftHeroSquareImage,
            'custom-clipped-side-image': kind === WebsiteBlockTextAndMediaType.HeroClippedSideImage || kind ===  WebsiteBlockTextAndMediaType.MediaLeftHeroClippedImage,
            'custom-hero-no-image': kind === WebsiteBlockTextAndMediaType.HeroNoImage,
            'custom-hero-background-image': kind === WebsiteBlockTextAndMediaType.HeroBackgroundImage,
            'custom-hero-image-left': kind ===  WebsiteBlockTextAndMediaType.MediaLeftHeroClippedImage || kind === WebsiteBlockTextAndMediaType.MediaLeftHeroSquareImage,
            'custom-clipped-side-image-left': kind === WebsiteBlockTextAndMediaType.MediaLeftHeroClippedImage}">
            <div class="hero-block-text d-flex align-items-center justify-content-center flex-column"
                [ngClass]="{'scss-media-left-hero-block': kind ===  WebsiteBlockTextAndMediaType.MediaLeftHeroClippedImage || kind === WebsiteBlockTextAndMediaType.MediaLeftHeroSquareImage}">
                @if (hasHeader) {
                    <h1 [ngClass]="{'text-center': kind === WebsiteBlockTextAndMediaType.HeroBackgroundImage || kind === WebsiteBlockTextAndMediaType.HeroNoImage}"
                        class="w-100 scss-website-block-customized-heading-font">
                        <ng-content select="[header]"></ng-content>
                    </h1>
                }
                @if (hasBody) {
                    <p [ngClass]="{'text-center': kind === WebsiteBlockTextAndMediaType.HeroBackgroundImage}" class="w-100 scss-website-block-customized-body-font">
                        <ng-content select="[body]"></ng-content>
                    </p>
                }
            </div>
            @if (kind !== WebsiteBlockTextAndMediaType.HeroNoImage) {
                <div
                    class="hero-block-image"
                    websiteBlockImage
                    [websiteMode]="Scope.websiteMode">

                    <lib-image-action-menu></lib-image-action-menu>
                    <ng-content select="[image]"></ng-content>
                </div>
            }
        </div>

    </div>
</ng-template>